import {useEffect, useState} from 'react'
import LimitManager from '../limitManager'

const limitUsageManager = (module, limitKey, organisationLimitUsages) => {
    const [limitState, setLimitState] = useState({
        usage: 0,
        value: 0,
        remainingUsageValue: 0,
        isLimitExceeded: false,
        title: ''
    })

    useEffect(() => {
        const limitUsages = LimitManager.getLimitUsages(module, limitKey, organisationLimitUsages)
        setLimitState({
            usage: limitUsages?.usage || 0,
            value: limitUsages?.value || 0,
            remainingUsageValue: (limitUsages?.value || 0) - (limitUsages?.usage || 0),
            isLimitExceeded: limitUsages?.usage >= limitUsages?.value,
            title: limitUsages?.title || ''
        })
    }, [organisationLimitUsages])

    return {...limitState}
}

export default limitUsageManager
